// NoteDrawer.jsx
import React from "react";
import { Drawer, Form, Input, Button, Space, message } from "antd";

export default function NoteDrawer({ open, onClose, onSubmit, initialNote }) {
  const [form] = Form.useForm();

  // Keep form in sync with open/initialNote
  React.useEffect(() => {
    if (open) {
      form.setFieldsValue({ note: initialNote ?? "" });
    } else {
      form.resetFields();
    }
  }, [open, initialNote, form]);

  const handleFinish = (values) => {
    const note = (values?.note || "").trim();
    onSubmit?.(note);
    message.success("Note saved");
    onClose?.();
  };

  return (
    <Drawer
      open={open}
      onClose={onClose}
      title="Add note"
      width={520}
      destroyOnClose
      extra={
        <Space>
          <Button type="primary" onClick={() => form.submit()}>
            Save
          </Button>
        </Space>
      }
    >
      <Form form={form} layout="vertical" onFinish={handleFinish}>
        <Form.Item
          name="note"
          label="Note"
          rules={[{ max: 1000, message: "Max 1000 characters" }]}
        >
          <Input.TextArea
            placeholder="Write the note…"
            showCount
            maxLength={1000}
            autoSize={{ minRows: 6, maxRows: 12 }}
          />
        </Form.Item>
      </Form>
    </Drawer>
  );
}
